import { useAuth } from '@berky/auth'
import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'

import type { HomepageNews } from './api'
import { useNotificationsApi } from './api'
import { HomepageNewsDialog } from './homepage-news-presentation'

export function HomepageNewsLoginDialog() {
  const { user } = useAuth()
  const api = useNotificationsApi()
  const [dismissedNewsId, setDismissedNewsId] = useState<string | null>(null)
  const news = useQuery({
    queryKey: ['homepage-news', 'claim', user?.id],
    queryFn: async ({ signal }) =>
      (await api.post<HomepageNews | undefined>(
        '/homepage-news/claim',
        {},
        { signal },
      )) ?? null,
    enabled: Boolean(user),
    staleTime: Infinity,
    refetchOnMount: false,
    retry: false,
  })

  const claimedNews = news.data
  if (!claimedNews || dismissedNewsId === claimedNews.id) return null

  return (
    <HomepageNewsDialog
      news={claimedNews}
      open
      onOpenChange={(open) => {
        if (!open) setDismissedNewsId(claimedNews.id)
      }}
    />
  )
}
